import { environment } from '../../environments/environment';

const date = new Date();
date.setDate(date.getDate() + 1);
date.setUTCHours(23, 55, 0, 0);

const tomorrow: Date = new Date();
tomorrow.setDate(new Date().getDate() + 1);
// tomorrow.setHours(8, 0, 0, 0);
const timestampOnCreateTimer: number = Math.floor(tomorrow.getTime() / 1000);

const tomorrowMidnight = date.getTime() / 1000;
date.setUTCHours(9, 0, 0, 0);

const tomorrowMorning = date.getTime() / 1000;
const userTimeZone = String(date.getTimezoneOffset() * -1);

const add2calendarTimestamp: number = Number(date.getTime() / 1000) - Number(userTimeZone) * 60;

const fontPath = `${environment.dmAssetsDomain}/creator/fonts/`;
const hostName = `optimove`;

const dpidDefault = '[%CAMPAIGN_ID%]';
const uidDefault = '${uid}';

export const DM_PARAMS_DEFAULT: any = {
	dpid: dpidDefault,
	uid: uidDefault
};

export const EPSILON_DPID = '${deploymentID}';

export const EPSILON_TENANT_ID = 10015;

export const COMPONENTS_TEMPLATES: any = {
	timer: [
		{
			name: 'New Countdown Timer',
			config: {
				type: 7,
				id: 'countdown',
				desc: 'Countdown Timer',
				version: 3,
				newapi: true,
				crontag: 'countdown',
				timestamp: timestampOnCreateTimer,
				timezone: userTimeZone,
				link: '',
				responsive: 0,
				personalized: false,
				web_version: false,
				base: {
					background: {
						'background-image': '',
						'background-color': '#8399C4',
						width: 320,
						height: 180
					},
					text: {
						font: `${fontPath}OpenSans-ExtraBold.ttf`,
						format: 'advanced',
						basic: {
							color: '#FFFFFF',
							top: 95,
							left: 50,
							align: 'center',
							'font-size': 32
						},
						elements: [
							{
								format: '%D',
								color: '#FFFFFF',
								'font-size': 32,
								left: 50,
								top: 95,
								align: 'left',
								letter_spacing: 0
							},
							{
								format: '%H',
								color: '#FFFFFF',
								'font-size': 32,
								left: 110,
								top: 95,
								align: 'left',
								letter_spacing: 0
							},
							{
								format: '%I',
								color: '#FFFFFF',
								'font-size': 32,
								left: 170,
								top: 95,
								align: 'left',
								letter_spacing: 0
							},
							{
								format: '%S',
								color: '#FFFFFF',
								'font-size': 32,
								left: 230,
								top: 95,
								align: 'left',
								letter_spacing: 0
							}
						]
					}
				},
				horizontal_lock: false,
				vertical_lock: false,
				color_lock: false,
				ios_privacy_fallback: '',
				ios_privacy_fallback_link: '',
				expiration_image: '',
				expiration_link: '',
				include_separators: false,
				separator_text: '/',
				separator_amount: 3,
				labels: {
					include_labels: true,
					font: `${fontPath}OpenSans-ExtraBold.ttf`,
					elements: [
						{
							type: 'Days',
							text: 'DAYS',
							color: '#ffffff',
							'font-size': 16,
							top: 120,
							left: 50,
							letter_spacing: 0
						},
						{
							type: 'Hours',
							text: 'HRS',
							color: '#ffffff',
							'font-size': 16,
							top: 120,
							left: 114,
							letter_spacing: 0
						},
						{
							type: 'Minutes',
							text: 'MIN',
							color: '#ffffff',
							'font-size': 16,
							top: 120,
							left: 173,
							letter_spacing: 0
						},
						{
							type: 'Seconds',
							text: 'SEC',
							color: '#ffffff',
							'font-size': 16,
							top: 120,
							left: 235,
							letter_spacing: 0
						}
					]
				}
			}
		}
	],

	'device-targeting': [
		{
			name: 'New Device Targeting',
			config: {
				type: 8,
				id: 'devicetargeting',
				desc: 'Device Targeting',
				version: '1',
				newapi: true,
				item_height: 51,
				item_width: 202,
				items: [
					{
						desc: 'Default',
						url: 'https://www.waze.com/',
						type: '1',
						image: `${environment.dmAssetsDomain}/creator/device_targeting/playappstore.gif`,
						regex: '.*'
					},
					{
						desc: 'iOS',
						url: 'https://itunes.apple.com/us/app/waze-social-gps-traffic/id323229106?mt=8',
						type: '3',
						image: `${environment.dmAssetsDomain}/creator/device_targeting/appstorestatic.png`,
						applink: '',
						regex: 'iPhone|iPad'
					},
					{
						desc: 'Android',
						url: 'https://play.google.com/store/apps/details?id=com.waze&referrer=utm_source%3Dgmm%26utm_campaign%3Dgmm_android',
						type: '6',
						image: `${environment.dmAssetsDomain}/creator/device_targeting/googleplay.png`,
						applink: '',
						regex: '(?=.*Android)(?!.*(Silk|Kindle|KFTT|KFARWI|KFTHWI|KFOT|KFJWI|KFSOWI|KFASWI|KFSAWI|KFSAWA|SD493))'
					}
				],
				responsive: 0
			}
		}
	],

	fade: [
		{
			name: 'New Fade',
			config: {
				type: 9,
				id: 'fade',
				desc: 'Fade',
				version: '1',
				newapi: true,
				width: 600,
				height: 400,
				link: '',
				images: [`${environment.dmAssetsDomain}/creator/fade/fade1.jpg`, `${environment.dmAssetsDomain}/creator/fade/fade2.jpg`],
				frame_duration: 2,
				responsive: 0
			}
		}
	],

	zoom: [
		{
			name: 'New Zoom',
			config: {
				type: 10,
				id: 'zoom',
				desc: 'Zoom',
				version: '1',
				newapi: true,
				image: `${environment.dmAssetsDomain}/creator/zoom/zoom.jpg`,
				link: '',
				responsive: 0
			}
		}
	],

	video: [
		{
			name: 'New Video',
			config: {
				type: 11,
				id: 'video',
				desc: 'Video',
				version: '1',
				newapi: true,
				item_width: 200,
				item_height: 168,
				videoSource: `${environment.dmAssetsDomain}/creator/video/video.mp4`,
				link: '',
				startat: '00:00:00',
				duration: 7,
				play_count: 0,
				max_physical_video_width: 400,
				play: {
					display: true,
					image: `${environment.dmAssetsDomain}/creator/video/video_play_btn.png`,
					duration: 1.0
				},
				video_tag: true,
				responsive: 0
			}
		}
	],

	whatsapp: [
		{
			name: 'New WhatsApp',
			config: {
				type: 12,
				id: 'whatsapp',
				desc: 'Whatsapp',
				version: 1,
				image: `${environment.dmAssetsDomain}/creator/whatsapp/whatsapp.png`,
				text: 'https://web.whatsapp.com/'
			}
		}
	],

	'dynamic-cta': [
		{
			name: 'New Dynamic CTA',
			config: {
				type: 13,
				id: 'shine',
				desc: 'Dynamic CTA',
				version: 2,
				newapi: true,
				image: `${environment.dmAssetsDomain}/creator/dynamic_cta/clickMe.png`,
				link: '',
				animation_type: 'cta',
				animation_url: 'lightning',
				responsive: 0
			}
		}
	],

	weather: [
		{
			name: 'New Weather',
			config: {
				type: 14,
				id: 'weather',
				desc: 'Weather',
				version: 2,
				newapi: true,
				crontag: 'weather',
				cords: '38.8338816,-104.8213634',
				location: 'Colorado Springs, CO, United States',
				background: {
					'background-image': '',
					color: '#8399c4',
					width: '1',
					height: '1'
				},
				base: {
					text: {
						font: `${fontPath}Arial.ttf`
					}
				},
				weather: {
					type: '2',
					show: 'fahrenheit'
				},
				language: 'english',
				days_color: '#ffffff',
				high_forecast_color: '#1d1d1d',
				low_forecast_color: '#ececec',
				iconsId: '2',
				icon_color: '#ffffff',
				num_of_days: 3
			}
		}
	],

	'web-scrape': [
		{
			name: 'New Web Scrape',
			config: {
				type: 15,
				id: 'webscreen',
				desc: 'Web Scrape',
				version: 2,
				newapi: true,
				crontag: 'webscrape',
				item_width: 562,
				item_height: 156,
				source: 'https://www.optimove.com/request-web-demo',
				link: 'https://www.optimove.com/request-web-demo',
				parser: {
					type: 1,
					left_offset: 42,
					top_offset: 330
				},
				responsive: 0,
				css: {},
				jquery: {},
				javascript: {},
				timestamp: {
					include_timestamp: false,
					font: 'Arial',
					'font-size': 12,
					color: '#000000',
					placement: 'bottom',
					alignment: 'left',
					background: '#cccccc',
					border: 1,
					border_color: '#000000',
					padding: 5,
					timezone: userTimeZone
				}
			}
		}
	],

	'add-to-calendar': [
		{
			name: 'New Add To Calendar',
			config: {
				type: 17,
				id: 'addtocalendar',
				desc: 'Add To Calendar',
				version: 2,
				newapi: true,
				event: {
					description: 'Add this event to your Calendar',
					location: 'New York',
					title: "Don't Miss Out!",
					timestamp: add2calendarTimestamp,
					duration: 120,
					timezone: userTimeZone,
					universal_event_time: false,
					time: '12:00'
				},
				text: {
					top: 36,
					color: '#4184f8',
					left: 21,
					align: 'center',
					font: 'Arial',
					'font-size': 18
				},
				labels: {
					outlook: 'Outlook',
					gmail: 'Gmail',
					apple: 'Apple',
					separator: ' | ',
					order: ['Outlook', 'Gmail', 'Apple'],
					bold: false,
					italic: false,
					underline: true
				}
			}
		}
	],

	map: [
		{
			name: 'New Map',
			config: {
				type: 18,
				id: 'map',
				desc: 'Map',
				version: 1,
				newapi: true,
				item_width: 300,
				item_height: 200,
				map_type: 'Google',
				navLink: false,
				link_type: 'Navigation',
				zoom: 15,
				location: '38.89767579999999,-77.03648269999997',
				address: '1600 Pennsylvania Avenue Northwest, Washington, DC, United States',
				nav_text: {
					include: true,
					text: 'Navigate To...',
					link: '',
					color: '#096fb8',
					font: `${fontPath}Arial.ttf`,
					'font-size': 17,
					background: '#ffffff'
				},
				icon_color: 'red',
				icon_url: '',
				responsive: 0
			}
		}
	],

	twitter: [
		{
			name: 'New Twitter',
			config: {
				type: 19,
				id: 'twitter',
				desc: 'Twitter',
				version: 2,
				newapi: true,
				source_tag: 'optimove',
				link: 'https://twitter.com/optimove',
				count: 4,
				total_duration: 14,
				background: {
					'background-color': '#ffffff',
					'background-image': `${environment.dmAssetsDomain}/creator/twitter/Twitter_logo_blue.jpg`,
					width: 200,
					height: 100
				},
				text: {
					font: `${fontPath}Arial.ttf`,
					'font-size': 17,
					color: '#096fb8'
				},
				responsive: 0,
				crontag: 'twitter',
				template: {
					custom_template: false
				}
			}
		}
	],

	'location-images': [
		{
			name: 'New Location Images',
			config: {
				type: 20,
				id: 'storelocator',
				desc: 'Location Images',
				version: 2,
				newapi: true,
				zip_locate: false,
				auto_dimension: false,
				item_width: 300,
				item_height: 200,
				no_radius: true,
				radius: 20,
				address_line: false,
				locations: [
					{
						address: '767 5th Ave, New York, NY 10153, United States',
						lat: 40.7635573,
						lng: -73.97230179999997,
						link_type: 'None',
						link: '',
						image_type: 'Google',
						image: '',
						icon_color: 'red'
					}
				],
				text: {
					font: `${fontPath}Arial.ttf`,
					'font-size': 17,
					color: '#1d1d1d'
				},
				background: {
					'background-color': '#ffffff'
				},
				responsive: 0
			}
		}
	],

	instagram: [
		{
			name: 'New Instagram',
			config: {
				type: 22,
				id: 'instagram',
				desc: 'Instagram',
				version: 1,
				newapi: true,
				crontag: 'instagram',
				item_width: 310,
				cols: 2,
				rows: 2,
				spacing: true,
				background: '#ffffff',
				'spacing-width': 10,
				repeat: 3,
				tag: 'go_optimove',
				link: 'https://instagram.com/go_optimove',
				responsive: 0
			}
		}
	],

	'personalized-image': [
		{
			name: 'New Personalized Image',
			config: {
				type: 23,
				id: 'personalimage',
				desc: 'Personalized Image',
				version: 2,
				newapi: true,
				source: `${environment.dmAssetsDomain}/creator/personalized_image/personalimage_default_Optimove.png`,
				link: '',
				width: 338,
				height: 212,
				responsive: 0,
				merge_array: [
					{
						merge_tag: '[-FIRSTNAME-]',
						tag_name: 'tag',
						default_text: 'Friend',
						text_cut_method: 'default',
						item_width: 305,
						item_height: 30,
						parser: {
							left_offset: 14,
							top_offset: 100
						},
						rotate: 0,
						text: {
							font: `${fontPath}Arial.ttf`,
							'font-size': 18,
							color: '#1d1d1d',
							text_alignment: 'left',
							transform: 'none',
							strikethrough: false
						}
					}
				]
			}
		}
	],

	custom: [
		{
			name: 'New Custom',
			config: {
				type: 24,
				id: 'custom',
				desc: 'Custom',
				version: 1,
				newapi: true,
				purpose: 'custom',
				method: 'test',
				text: '',
				'ui-form': {
					packages: [
						{
							key: 'image_params',
							label: 'Image Params',
							required: false,
							type: 'textBox',
							defaultValue: null,
							order: 0
						},
						{
							key: 'url-box',
							label: 'Url Box',
							required: false,
							type: 'urlBox',
							defaultValue: null,
							order: 1
						},
						{
							key: 'font-box',
							label: '',
							required: true,
							type: 'fontBox',
							defaultValue: {
								font: `${fontPath}Arial_Black.ttf`,
								size: 6,
								custom: ''
							},
							order: 2
						},
						{
							key: 'text-color',
							label: 'Color Picker',
							required: false,
							type: 'colorPicker',
							defaultValue: '#121212',
							order: 3
						},
						{
							key: 'date',
							label: '',
							required: false,
							type: 'datePicker',
							defaultValue: {
								timestamp: tomorrowMorning,
								dateTime: new Date(),
								time: new Date()
							},
							order: 4
						},
						{
							key: 'image-box',
							label: 'Image Box',
							required: false,
							type: 'imageBox',
							defaultValue: null,
							order: 5
						},
						{
							key: 'multiSelectedValues',
							label: 'Multi Select Box',
							required: false,
							type: 'multiSelect',
							defaultValue: [
								{
									id: '1',
									itemName: 'Option 1'
								}
							],
							options: null,
							externalOptions: null,
							settings: {
								primaryKey: 'id',
								labelKey: 'itemName',
								placeholder: 'Choose Items',
								singleSelection: false
							},
							order: 6
						},
						{
							key: 'text-area',
							label: 'Text Area',
							required: false,
							type: 'textArea',
							defaultValue: 'This is a Text Area',
							order: 7
						},
						{
							key: 'dropdown',
							label: 'Dropdown',
							required: false,
							type: 'selectBox',
							options: [
								{
									value: 'option1',
									label: 'Option 1'
								},
								{
									value: 'option2',
									label: 'Option 2'
								}
							],
							defaultValue: 'option1',
							order: 8
						},
						{
							key: 'radio',
							label: 'Radio Buttons',
							required: false,
							type: 'radioButton',
							options: [
								{
									value: 'option1',
									label: 'Option 1'
								},
								{
									value: 'option2',
									label: 'Option 2'
								}
							],
							defaultValue: 'option1',
							order: 9
						},
						{
							key: 'checkbox',
							label: 'Checkbox',
							required: false,
							type: 'checkBox',
							options: {
								value: false,
								label: 'Option Label'
							},
							defaultValue: false,
							order: 10
						},
						{
							key: 'searchbox',
							label: 'Search Box',
							required: false,
							type: 'searchBox',
							externalOptions: 'https://restcountries.eu/rest/v2/name/',
							//            'externalOptions':'https://api.github.com/search/users',
							settings: {
								optionField: 'name',
								optionFieldResultOnly: false,
								queryParameter: null,
								dataKey: null,
								placeholder: 'Search...'
								//              'optionField': 'login',
								//              'queryParameter': 'q',
								//              'dataKey': 'items'
							},
							order: 11
						},
						{
							key: 'file-box',
							label: 'File Box',
							required: false,
							type: 'fileBox',
							settings: {
								additionalFields: true
							},
							defaultValue: [''],
							order: 12
						}
					]
				}
			}
		}
	],

	'engagement-tracker': [
		{
			name: 'New Engagement Tracker',
			config: {
				type: 25,
				id: 'reportingpixel',
				desc: 'Reporting Pixel',
				version: 1,
				newapi: true,
				trackParams: {
					dpid: dpidDefault,
					uid: uidDefault
				},
				dm_params: {
					dpid: dpidDefault,
					uid: uidDefault
				}
			}
		}
	],

	'pop-up': [
		{
			name: 'New Pop Up',
			config: {
				type: 26,
				id: 'popup',
				desc: 'Pop up',
				version: 1,
				newapi: true,
				template_width: 400,
				image: `${environment.dmAssetsDomain}/creator/popup/popup_Optimove.png`,
				link: 'https://www.optimove.com/request-web-demo',
				top_offset: 85,
				left_offset: 70,
				overlay_opacity: 30,
				close_text: 'Close',
				'font-size': 17,
				text_color: '#000',
				close_position: 'Top Right',
				close_btn_type: 'image',
				font: `${fontPath}Arial_Black.ttf`,
				opening_effect: {
					value: 'effect-1'
				},
				responsive: 0,
				close_btn_image: `${environment.dmAssetsDomain}/creator/popup/close_btn_image.png`,
				use_external: {
					image: false,
					add_image_tracking: false,
					link: false,
					add_link_tracking: false
				}
			}
		}
	],

	'segmented-images': [
		{
			name: 'New Segmented Images',
			config: {
				type: 32,
				id: 'imagemerge',
				desc: 'Segmented Images',
				version: 3,
				newapi: true,
				source: `${environment.dmAssetsDomain}/creator/segmented_images/segmented_images_blue_Optimove.png`,
				link: 'https://www.optimove.com/',
				merge_tag: '[%Example%]',
				responsive: 0,
				use_external_csv: 0,
				item_width: 338,
				item_height: 212,
				items: [
					{
						tag: 'first_merge_tag_value',
						image: `${environment.dmAssetsDomain}/creator/segmented_images/segmented_images_gray_Optimove.png`
					},
					{
						tag: 'second_merge_tag_value',
						image: `${environment.dmAssetsDomain}/creator/segmented_images/segmented_images_orange_Optimove.png`
					}
				]
			}
		}
	],

	carousel: [
		{
			name: 'New Carousel',
			config: {
				type: 36,
				id: 'combined_slider',
				desc: 'Carousel',
				version: 2,
				newapi: true,
				item_width: 200,
				item_height: 200,
				speed: 20,
				count: 12,
				items_per_frame: 3,
				animation_type: 'horizontal',
				scroll_type: 'ticker',
				responsive: 0,
				use_external: {
					image: false,
					add_image_tracking: false,
					link: false,
					add_link_tracking: false
				},
				items: [
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img1_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img2_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img3_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img4_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img5_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img6_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img7_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img8_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img9_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img10_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img11_1.jpg`,
						link: ''
					},
					{
						imageURL: `${environment.dmAssetsDomain}/creator/carousel/img12_1.jpg`,
						link: ''
					}
				],
				gif_fallback: false
			}
		}
	],

	'image-swap': [
		{
			name: 'New Image Swap',
			config: {
				type: 38,
				id: 'imageswap',
				desc: 'Image Swap',
				version: 2,
				newapi: true,
				daily: false,
				item_width: 500,
				item_height: 227,
				items: [
					{
						swap_time: Math.floor((new Date().getTime() - 24 * 60 * 60 * 1000) / 1000),
						imageURL: `${environment.dmAssetsDomain}/creator/image_swap/image_swap1.png`,
						linkURL: '',
						daily_start_time: Math.floor((new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000) / 1000)
					},
					{
						swap_time: Math.floor((new Date().getTime() + 2 * 24 * 60 * 60 * 1000) / 1000),
						imageURL: `${environment.dmAssetsDomain}/creator/image_swap/image_swap2.png`,
						linkURL: '',
						daily_start_time: Math.floor((new Date().setHours(12, 0, 0, 0) - 24 * 60 * 60 * 1000) / 1000)
					}
				],
				timezone: userTimeZone,
				responsive: 0
			}
		}
	],

	'news-ticker': [
		{
			name: 'New News Ticker',
			config: {
				type: 39,
				id: 'newscarousel',
				desc: 'News Ticker',
				version: 2,
				newapi: true,
				responsive: 0,
				background: {
					'background-color': '#ff8560'
				},
				text: {
					font: `${fontPath}OpenSans-Regular.ttf`,
					'font-size': 18,
					color: '#1d1d1d'
				},
				source: 'https://www.optimove.com/blog/feed',
				link: 'https://www.optimove.com/blog/',
				item_width: 400,
				item_height: 50,
				crontag: 'newsticker',
				scroll_type: 'ticker',
				count: 4,
				total_duration: 14,
				animation_type: 'horizontal',
				items_per_frame: 1
			}
		}
	],

	'geo-targeted-images': [
		{
			name: 'New Geo Targeted Images',
			config: {
				type: 40,
				id: 'geotargetedimages',
				desc: 'Geo Targeted Images',
				version: 1,
				item_width: 403,
				item_height: 417,
				address_line: false,
				text: {
					font: `${fontPath}Arial.ttf`,
					'font-size': 17,
					color: '#858585'
				},
				background: {
					'background-color': '#ffffff'
				},
				locations: [
					{
						address: '767 5th Ave, New York, NY 10153, United States',
						lat: 40.7635573,
						lng: -73.97230179999997,
						link: '',
						image_type: 'Custom',
						link_type: 'None',
						image: `${environment.dmAssetsDomain}/creator/geo-targeted_images/geotargetedimages.jpg`,
						icon_color: 'red'
					}
				],
				no_radius: true,
				radius: 20,
				responsive: 0
			}
		}
	],

	reveal: [
		{
			name: 'New Reveal',
			config: {
				type: 41,
				id: 'reveal',
				desc: 'Reveal',
				version: 1,
				newapi: true,
				bottom_image: {
					image_url: `${environment.dmAssetsDomain}/creator/reveal/reveal_coupon_Optimove.png`,
					link_url: 'https://www.optimove.com/'
				},
				top_image: {
					image_url: `${environment.dmAssetsDomain}/creator/reveal/reveal_coupon_cover_Optimove.gif`
				},
				responsive: 0,
				use_external: {
					image: false,
					add_image_tracking: false,
					link: false,
					add_link_tracking: false
				}
			}
		}
	],

	'asset-generator': [
		{
			name: 'New Asset Generator',
			config: {
				type: 42,
				id: 'assetgenerator',
				desc: 'Asset Generator',
				version: 1,
				newapi: true,
				purpose: 'custom',
				feed_url: 'http://prod.dyneml.com/campaign/optimove/20200505/optimove_blog.json',
				ua: '',
				iterator_path: 'assets',
				no_iterator_path: false,
				link_key: 'url',
				prepend_to_link: '',
				fallback_link: 'https://www.optimove.com',
				item_template_url: 'http://prod.dyneml.com/campaign/optimove/20200505/template_blog.html',
				selector: '.pi_item',
				js_url: '',
				single_element: false,
				item_count: 5,
				crontag: 'assetgenerator',
				cronfrequency: 260000,
				mapping_params: [
					{
						token: '{{background}}',
						name: 'background',
						required: false,
						fallback: ''
					},
					{
						token: '{{headline}}',
						name: 'title',
						required: false,
						fallback: ''
					},
					{
						token: '{{author}}',
						name: 'author',
						required: false,
						fallback: ''
					},
					{
						token: '{{publish}}',
						name: 'publish',
						required: false,
						fallback: ''
					},
					{
						token: '{{tags}}',
						name: 'tags',
						required: false,
						fallback: ''
					}
				],
				fallback_image: ''
			}
		}
	],

	gallery: [
		{
			name: 'New Gallery',
			config: {
				type: 44,
				id: 'gallery',
				desc: 'Gallery',
				version: 1,
				newapi: true,
				responsive: 0,
				arrow_img_src: {
					left: `${environment.dmAssetsDomain}/creator/gallery/arrow_left_default.png`,
					right: `${environment.dmAssetsDomain}/creator/gallery/arrow_right_default.png`
				},
				fallback: {
					type: 'animation',
					image_url: '',
					link_url: '',
					use_first_image: false
				},
				images: [
					{
						src: `${environment.dmAssetsDomain}/creator/gallery/img1_1.jpg`,
						url: ''
					},
					{
						src: `${environment.dmAssetsDomain}/creator/gallery/img2_1.jpg`,
						url: ''
					}
				],
				use_external: {
					image: false,
					add_image_tracking: false,
					link: false,
					add_link_tracking: false
				}
			}
		}
	],

	'rule-engine': [
		{
			name: 'New Rule Engine',
			config: {
				type: 49,
				version: '1',
				desc: 'Rule Engine',
				id: 'ruleengine',
				width: '338',
				height: '212',
				responsive: 0,
				cta: true,
				rules: [
					{
						image_url: 'https://creator-ui-dev.dyneml.com/cms/4533589684092/personalimage_default_Optimove.png',
						link: 'https://www.optimove.com',
						data: [
							{
								condition: '',
								value: '',
								type: '',
								qualifier: '',
								operator: ''
							}
						]
					}
				],
				fallback: {
					image_url: 'https://creator-ui-dev.dyneml.com/cms/4533589684092/338x212_1594839087937_fallback.png',
					link: 'https://www.optimove.com'
				},
				tracking_parameters: ''
			}
		}
	],

	recommendation: [
		{
			name: 'New Recommendation',
			config: {
				type: 50,
				id: 'recommendation',
				desc: 'Recommendation',
				version: 1,
				newapi: true,
				source_type: 'data',
				data_source: 'optimove',
				visual_editor_snippet: false,
				locked_content: false,
				merge_tags: {
					primary: '[%primary%]',
					default: '[%default%]',
					fallback: '[%fallback%]'
				},
				header_image: `${environment.dmAssetsDomain}/creator/recommendation/recommendation_header.png`,
				cta: true,
				cta_key: 'cta_key',
				tracking_parameters: '',
				cols: 2,
				rows: 1,
				item_width: 600,
				item_height: 400,
				responsive: 0,
				extendable: false,
				extendable_padding: 0,
				spacing: 0,
				spacing_color: '#ffffff',
				background: {
					'background-image': `${environment.dmAssetsDomain}/creator/recommendation/recommendation_background.png`,
					'background-color': '#ffffff'
				},
				bidirectional_text: false,
				items: [
					{
						type: 'text',
						key: 'data_column_mapping',
						use_data_source: false,
						relative: false,
						top: 20,
						left: 50,
						height: 50,
						width: 200,
						image: `${environment.dmAssetsDomain}/creator/recommendation/recommendation_button.png`,
						image_fit: 'cover',
						image_fit_position: 'center',
						image_fit_background: '#ffffff',
						text: {
							font: `${fontPath}Arial.ttf`,
							'font-size': 25,
							color: '#1d1d1d',
							text_alignment: 'center',
							transform: 'none',
							strikethrough: false
						},
						text_content: 'Call to Action',
						text_cut_method: 'cut',
						last_line_text_cut_method: 'cut',
						lines: 2,
						line_height: 1.5
					}
				],
				fallback: 'collapse',
				fallback_collapse_cta: 'http://www.optimove.com',
				fallback_items: [
					{
						link: '',
						image: ''
					}
				]
			}
		}
	],

	coupon: [
		{
			name: 'New Coupon',
			config: {
				type: 51,
				id: 'coupon',
				desc: 'Coupon',
				version: 1,
				newapi: true,
				csv_list: [`${environment.dmAssetsDomain}/creator/coupon/coupons.csv`],
				coupon_expires: false,
				link: '',
				default_image: `${environment.dmAssetsDomain}/creator/coupon/coupon_sample.png`,
				default_link: '',
				background: {
					'background-color': '#ffffff',
					'background-image': ''
				},
				text: {
					font: `${fontPath}Arial.ttf`,
					'font-size': 20,
					color: '#000000'
				},
				notification_amount: 1,
				email: '',
				notification_sent: false,
				crontag: 'coupon',
				dm_params: {
					dpid: dpidDefault,
					uid: uidDefault
				}
			}
		}
	],

	survey: [
		{
			name: 'New Survey',
			config: {
				type: 52,
				id: 'survey',
				desc: 'Survey',
				version: 2,
				newapi: true,
				link: 'https://optimove.com',
				item_width: 430,
				spacing: 10,
				rows: 1,
				cols: 2,
				responsive: 0,
				visual_editor_stack: false,
				visual_editor_split: false,
				items: [
					{
						response: 'YES',
						image: `${environment.dmAssetsDomain}/creator/survey/yes_survey.png`
					},
					{
						response: 'NO',
						image: `${environment.dmAssetsDomain}/creator/survey/no_survey.png`
					}
				],
				dm_params: {
					dpid: '[%CAMPAIGNID%]',
					uid: '[%CUSTOMER_ID%]'
				}
			}
		}
	],

	barcode: [
		{
			name: 'New Barcode',
			config: {
				type: 53,
				id: 'barcode',
				desc: 'Barcode',
				version: 1,
				newapi: true,
				csv_list: [`${environment.dmAssetsDomain}/creator/barcode/codes.csv`],
				barcode: 'code128',
				scale_x: 2,
				scale_y: 10,
				bar_color: '#000000',
				barcode_expires: false,
				link: '',
				fallback: {
					type: 'code',
					default_code: '0123456789',
					default_image: '',
					default_link: ''
				},
				background: {
					'background-color': '#ffffff'
				},
				include_text: true,
				text: {
					font: `Default`,
					'font-size': 20,
					color: '#000000'
				},
				notification_amount: 1,
				email: '',
				notification_sent: false,
				crontag: 'barcode',
				dm_params: {
					dpid: dpidDefault,
					uid: uidDefault
				}
			}
		}
	],

	translate: [
		{
			name: 'New Translate',
			config: {
				type: 54,
				id: 'translate',
				desc: 'Translate',
				version: 1,
				newapi: true,
				translation_type: 'single',
				optimail_conditional: false,
				merge_tag: '',
				source: {
					language: 'en',
					text: 'Enter your text or HTML for translation...'
				},
				translation: [
					{
						language: 'fr',
						text: '',
						merge_tag_value: '',
						locked: true
					}
				]
			}
		}
	],

	'progress-bar': [
		{
			name: 'New Progress Bar',
			config: {
				type: 55,
				id: 'progressbar',
				desc: 'Progress Bar',
				version: 1,
				newapi: true,
				link: '',
				merge_tag: '[%tag_value%]',
				bar_scale_maximum: 100,
				bar_style: 'line',
				bar_size: 30,
				bar_ends: 'round',
				bar_color: '#1D1D1D',
				bar_background: '#A8B8CD',
				use_gradient: false,
				bar_color_gradient: '#ff8560',
				item_width: 300,
				item_height: 65,
				background: {
					'background-color': '#ffffff'
				},
				include_text: true,
				text: {
					font: `${fontPath}Arial_Black.ttf`,
					'font-size': 25,
					color: '#1D1D1D',
					placement: 'bottom',
					alignment: 'center'
				},
				responsive: 0
			}
		}
	]
};
